import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { useSecondarySettlements } from "../../../context/contractDataLoaderService";
import UiTable from "../../../components/table/Table";
import {
  SecondaryIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";
import { useVerifiedSecurity } from "../../../context/verifiedWalletData";
import { useGlobal } from "../../../context/globalContext";

import Web3 from "web3";
import { providers } from "ethers";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { useAccount, useClient, useConnectorClient } from "wagmi";

function InvestorInfo(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    isUpdate,
    setIsUpdate,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [tableData, setTableData] = useState([]);
  const category = props.match.params.category;
  const securityAddress = props.match.params.securityAddress;
  let { data: verifiedSecurity } = useVerifiedSecurity(
    securityAddress,
    isUpdate
  );
  const { data: secondaryInvestors, loading } =
    useSecondarySettlements(verifiedSecurity);

  const getUniqueInvestors = (investors) => {
    const refs = new Set();
    return investors.reduce((acc, inv) => {
      if (!refs.has(inv.ref)) {
        refs.add(inv.ref);
        acc.push(inv);
      }
      return acc;
    }, []);
  };

  let filteredData = secondaryInvestors
    ? getUniqueInvestors(secondaryInvestors)
    : [];

  let headers;
  let pageHeading;

  let secondaryIssueManagerContract;

  if (provider && provider.getSigner && chainId && address) {
    if (contractAddress[chainId].BalancerSecondaryIssueManager) {
      secondaryIssueManagerContract = new SecondaryIssueManager(
        signer,
        contractAddress[chainId].BalancerSecondaryIssueManager
      );
    }
  }

  pageHeading = "Secondary Investors";
  if (category == "transactions") {
    headers = [
      { label: "Seller", val: "transferorNameAsLink" },
      { label: "Price", val: "price" },
      { label: "Qty", val: "unitsToTransfer" },
      { label: "Buyer", val: "transfereeNameAsLink" },
      { label: "Execution Date(UTC)", val: "date" },
      { label: "Currency", val: "currencySymbolFmt" },
      userRole == "DP" || userRole == "intermediary"
        ? { label: "Call Action", val: "buttonDetails" }
        : {},
    ];
  } else {
    headers = [
      { label: "Investor name", val: "transferorName" },
      { label: "Investor Address", val: "transferor" },
      { label: "Record date", val: "scheduledRecordDate" },
      { label: "Balance", val: "updateBalance" },
      { label: "Earning", val: "updateEarnings" },
      userRole == "DP" || userRole == "intermediary"
        ? { label: "Call Action", val: "secondaryInvestorCallAction" }
        : {},
    ];
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="">
            <h3 className="">{pageHeading}</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={filteredData || []}
            hover
            bordered={false}
            contract={secondaryIssueManagerContract}
            chainId={chainId}
            signer={signer}
            web3={web3}
            verifiedWalletDetails={verifiedWalletDetails}
            account={account}
          />
        </div>
      </section>
    </>
  );
}

export default function SecondaryInvestorDetail(props) {
  return <InvestorInfo {...props} />;
}
